import { render, staticRenderFns } from "./vsphere-volume.vue?vue&type=template&id=2104d5fe&"
import script from "./vsphere-volume.vue?vue&type=script&lang=js&"
export * from "./vsphere-volume.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports